import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoCashregItem} from "./models/DtoCashregItem";

@Injectable()
export class CashregWeekService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'administration'
    }

    public getCashregByWeek = (year: number, week: number): Observable<DtoCashregItem[]> => {
        return this.http.get<DtoCashregItem[]>(`${this.apiUrl}/cashreg/${year}/${week}`);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/administration/cashreg-week/cashreg-week.service.ts